
import TalentSkill from '../TalentSkill'

const HasRequiredExperience = WrappedClass => {

    return class HasRequiredExperience extends WrappedClass {

	    groupedRequiredExp(prop)
	    {
	        return TB.groupBy(
	            this[prop], 'importance'
	        );
	    }

	    requiredExpOf(importance, prop)
	    {
	        let skills = this.groupedRequiredExp(prop)[
	            importance
	        ];

	        if (!TB.isArray(skills)) {
	            skills = [];
	        }

	        return skills;

	        // return TalentSkill.makeMany(skills);
	    }

	    veryImportantExpRequired(prop)
	    {
	        return this.requiredExpOf(
	            TalentSkill.ImportanceLevels.VeryImportant, prop
	        );
	    }

	    findMatchingVeryImportantExp(possibleMatches, prop)
	    {
	    	return this.findMatchingExp(
	    		possibleMatches, this.veryImportantExpRequired(
	    			prop
	    		)
	    	);
	    }

	    importantExpRequired(prop)
	    {
	        return this.requiredExpOf(
	            TalentSkill.ImportanceLevels.Important, prop
	        );
	    }

	    findMatchingImportantExp(possibleMatches, prop)
	    {
	    	return this.findMatchingExp(
	    		possibleMatches, this.importantExpRequired(
	    			prop
	    		)
	    	);
	    }

	    niceToHaveExpRequired(prop)
	    {
	        return this.requiredExpOf(
	            TalentSkill.ImportanceLevels.NiceToHave, prop
	        );
	    }

	    findMatchingNiceToHaveExp(possibleMatches, prop)
	    {
	    	return this.findMatchingExp(
	    		possibleMatches, this.niceToHaveExpRequired(
	    			prop
	    		)
	    	);
	    }

	    maxExpScore(prop)
	    {
	        let veryImportant = this.veryImportantExpRequired(prop).length * TalentSkill.MaxScore * TalentSkill.veryImportantLevelMultiplier(),
	            important = this.importantExpRequired(prop).length * TalentSkill.MaxScore * TalentSkill.importantLevelMultiplier(),
	            niceToHave = this.niceToHaveExpRequired(prop).length * TalentSkill.MaxScore * TalentSkill.niceToHaveLevelMultiplier();

	        return veryImportant + important + niceToHave;
	    }

	    maxAvgExpScore(prop)
	    {
	        let totalRequired = this[prop].length;
	        if (!totalRequired) {
	        	return 0;
	        }

	        return this.maxExpScore(prop) / totalRequired;
	    }

	    findVeryImportantMatchingExpWeightedScore(possibleMatches, prop)
	    {
	    	return TB.sumBy(
	    		this.findMatchingVeryImportantExp(possibleMatches, prop), 'talent_score'
	    	) * TalentSkill.veryImportantLevelMultiplier();
	    }

	    findImportantMatchingExpWeightedScore(possibleMatches, prop)
	    {
	    	return TB.sumBy(
	    		this.findMatchingImportantExp(possibleMatches, prop), 'talent_score'
	    	) * TalentSkill.importantLevelMultiplier();
	    }

	    findNiceToHaveMatchingExpWeightedScore(possibleMatches, prop)
	    {
	    	return TB.sumBy(
	    		this.findMatchingNiceToHaveExp(possibleMatches, prop), 'talent_score'
	    	) * TalentSkill.niceToHaveLevelMultiplier();
	    }

	    findMatchingExpWeightedScore(possibleMatches, prop)
	    {
	    	return this.findVeryImportantMatchingExpWeightedScore(possibleMatches, prop)
                + this.findImportantMatchingExpWeightedScore(possibleMatches, prop)
                + this.findNiceToHaveMatchingExpWeightedScore(possibleMatches, prop);
	    }

	    findMatchingExp(possibleMatches, requiredExps)
	    {
	    	let matches = [];
	    	for (let possibleMatch of possibleMatches) {
				for (let requiredExp of requiredExps) {
					if (requiredExp.id !== possibleMatch.id) {
						continue;
					}
					matches.push(possibleMatch);
					break;
				}
			}
	    	return matches;
	    }

	    skillsProp()
	    {
	    	if (this.skills) {
	    		return 'skills';
	    	}

	    	return 'skills';
	    }

	    requiredSkills()
	    {
	    	return this[this.skillsProp()];
	    }

	    findMatchingSkills(possibleMatches)
	    {
	    	return this.findMatchingExp(possibleMatches, this.requiredSkills());
	    }

	    veryImportantSkillsRequired()
	    {
	    	return this.veryImportantExpRequired(this.skillsProp());
	    }

	    importantSkillsRequired()
	    {
	    	return this.importantExpRequired(this.skillsProp());
	    }

	    niceToHaveSkillsRequired()
	    {
	    	return this.niceToHaveExpRequired(this.skillsProp());
	    }

	    findMatchingVeryImportantSkills(possibleMatches)
	    {
	    	return this.findMatchingVeryImportantExp(
	    		possibleMatches, this.skillsProp()
	    	);
	    }

	    findMatchingImportantSkills(possibleMatches, prop)
	    {
	    	return this.findMatchingImportantExp(
	    		possibleMatches, this.skillsProp()
	    	);
	    }

	    findMatchingNiceToHaveSkills(possibleMatches, prop)
	    {
	    	return this.findMatchingNiceToHaveExp(
	    		possibleMatches, this.skillsProp()
	    	);
	    }

	    findMatchingSkillsWeightedScore(possibleMatches, prop)
	    {
	    	return this.findMatchingExpWeightedScore(possibleMatches, this.skillsProp());
	    }

	    maxSkillsScore()
	    {
	    	return this.maxExpScore(this.skillsProp());
	    }
    }
}


export default HasRequiredExperience